import { Box, Text } from '@medely/ui-kit';
import { HideFrom } from '@mp/components/HideFrom';
import React from 'react';

export const CancelAssignmentModalInfo = () => {
  return (
    <Box testId="cancel-assignment-modal-info">
      <HideFrom
        agency
        fallback={
          <Text size="m">
            To cancel your booked assignment in its entirety, please reach out to your agency as
            soon as possible.
          </Text>
        }
      >
        <Text size="m">
          To cancel your booked assignment in its entirety, please contact Medely Support through
          the chat button as soon as possible.
        </Text>
      </HideFrom>
    </Box>
  );
};
